import React from 'react';

export default function ThreeDotsMenuIcon({
  width = 4,
  height = 16,
  fill = '#171C33',
  fillOpacity = 0.5,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2" r="1.5" fill={fill} fillOpacity={fillOpacity} />
      <circle cx="2" cy="8" r="1.5" fill={fill} fillOpacity={fillOpacity} />
      <circle cx="2" cy="14" r="1.5" fill={fill} fillOpacity={fillOpacity} />
    </svg>
  );
}
